// db.ts

import Dexie, { Table } from 'dexie';
import { t } from 'i18next';
import { IDynamicCard } from 'src/app/pages/HomePage/Card/home-card.config';
import { DYNAMIC_CARDS } from 'src/app/pages/HomePage/Cards';
import { filterCards } from 'src/app/pages/HomePage/home-page.config';

interface Meta {
  key: string;
  value: any;
}

let dbInstance: MySubClassedDexie | null = null;
export class MySubClassedDexie extends Dexie {
  Cards!: Table<IDynamicCard<any>>;

  meta!: Table<Meta, string>;

  constructor(permissions: string[]) {
    super('cards');
    this.version(5)
      .stores({
        Cards: '++id',
        meta: 'key',
      })
      .upgrade(async (trans) => {
        await trans.table('Cards').clear();
        const newCards = filterCards(
          DYNAMIC_CARDS.map((card) => ({ ...card, title: t(card.title) })),
          permissions,
        );
        await trans.table('Cards').bulkAdd(newCards);
      });
  }
}

export const initDB = async (permissions: string[]) => {
  if (!dbInstance) {
    dbInstance = new MySubClassedDexie(permissions);
    await dbInstance.open();
  }
  return dbInstance;
};

export const getDB = () => {
  if (!dbInstance) throw new Error('Dexie instance not initialized');
  return dbInstance;
};

export const syncCardsWithDB = async (nextCards: IDynamicCard<any>[]) => {
  const db = getDB();
  const existingCards = db.Cards.toArray();

  const nextIds = new Set(nextCards.map((card) => card.id));
  const idsToDelete = (await existingCards).filter((card) => !nextIds.has(card.id)).map((card) => card.id);

  if (idsToDelete.length) {
    await db.Cards.bulkDelete(idsToDelete);
  }
  await db.Cards.bulkPut(nextCards);
};
